import theme, { createStyles,ThemeVars } from 'core/utilities/theme';

export default createStyles({
  env: {
    marginLeft: '-1px',
    width: 'calc(100% + 2px)',
    marginTop: '-1px',
    paddingTop: '1px',
    paddingBottom: '1px',
    height: ThemeVars.headerEnvHeight,
    background: theme.palette.background.default,
    color: theme.palette.text.primary,
    textAlign: 'center',
  },
  toolbar: {
    maxHeight: { xs: ThemeVars.headerMenuHeight },
    minHeight: { xs: ThemeVars.headerMenuHeight },
    display: 'flex',
    flexDirection: 'row',
  },
  title1: {
    whiteSpace: 'nowrap',
    fontWeight: 500,
    color: 'white',
  },
  title2: {
    whiteSpace: 'nowrap',
  },
  search: {
    marginLeft: theme.spacing(2),
    marginTop: '-5px',
    marginRight: theme.spacing(1),
    minWidth: '300px',
    '& p, label, input, div': {
      fontSize: theme.typography.body2.fontSize,
    },
    '& .MuiInputBase-root': {
      backgroundColor: 'white',
      borderRadius: '4px',
    },
    '& .placeholder': {
      padding: '4px 8px !important',
    },
  },
  searchIcon: {
    marginRight: theme.spacing(-1),
  },
  searchCollapsed: {
    margin: theme.spacing(0, 1),
    backgroundColor: 'white',
    borderRadius: theme.spacing(0.5),
    boxShadow: 'inset 0 0 2px 0 #000000',
    '& button': {
      padding: theme.spacing(1),
    },
  },
  logo: {
    maxHeight: ThemeVars.headerMenuHeight,
    verticalAlign: 'middle',
    marginRight: theme.spacing(1),
  },
  user: {
    '& button': {
      minWidth: 0,
    },
  },
});
